import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * Layout for `/my/feedback/*`: index = Typeform (`my.feedback.index.tsx`),
 * `$feedbackId` = service/order feedback (`my.feedback.$feedbackId.tsx`).
 */
function MyFeedbackLayout() {
  return <Outlet />;
}

export const Route = createFileRoute("/(member)/(protected)/my/feedback")({
  component: MyFeedbackLayout,
});
